import { memo } from "react";
import { bool, oneOf, string } from "prop-types";
import { capitalize, Grid } from "@material-ui/core";
import { DragIndicator } from "@material-ui/icons";
import useStyle from "./DragHandleCell.style";
import useCellStyle from "../../../../styles/CommonTableCellStyles.style";
import classnames from "classnames";

export const DragHandleCell = memo(({
  isHeader,
  displayHandle,
  presetClass,
  size="large"
}) => {
  const classes = useStyle();
  const cellClasses = useCellStyle();

  return (
    <Grid
      item
      container
      role="rowitem"
      alignItems="flex-start"
      className={classnames(
        "pr-2 dragHandleContainer noExpand",
        "preset-noedit",
        presetClass,
        classes.dragHandleCell,
        isHeader && cellClasses.headCell,
      )}
    >
      <Grid
        item container
        alignItems="center"
        wrap="nowrap"
        className={classnames(
          !isHeader && cellClasses[`sizeInner${capitalize(size)}`]
        )}
      >
        {
          displayHandle &&
          <DragIndicator
            className={classnames(
              "dragHandle hoverIcon opq",
              classes.handle,
            )}
          />
        }
      </Grid>
    </Grid>
  );
});

DragHandleCell.propTypes = {
  isHeader: bool,
  displayHandle: bool,
  presetClass: string,
  size: oneOf(["xSmall", "small", "medium", "large", "xLarge", "2XLarge"]),
};
